<script lang="ts">
	import { cn } from "#lib/web-ui/ui/utils.js";
	import type { WithElementRef } from "bits-ui";
	import type { HTMLAttributes } from "svelte/elements";

	export type SectionTheme = "light" | "dark" | "muted";

	let {
		ref = $bindable(null),
		theme = "light" as SectionTheme,
		class: className,
		children,
		...restProps
	}: {
		theme?: SectionTheme;
		class?: string;
	} & WithElementRef<HTMLAttributes<HTMLElement>> = $props();

	const themeClasses: Record<SectionTheme, string> = {
		light: "bg-background",
		dark: "dark bg-background",
		muted: "muted bg-background"
	};
</script>

<section
	bind:this={ref}
	class={cn("py-16 md:py-24", themeClasses[theme], className)}
	{...restProps}
>
	<div class="mx-auto max-w-[84rem] px-4 md:px-6">
		{@render children?.()}
	</div>
</section>
